import React from 'react';
import './WordDisplay.css';

function WordDisplay({ targetWord, currentStep, userInput, description, image, currentCharIndex = 0 }) {
  const renderWord = () => {
    if (!targetWord) return null;

    return targetWord.split('').map((char, index) => {
      const isCompleted = index < currentCharIndex;
      const isCurrent = index === currentCharIndex;
      
      return (
        <span 
          key={index} 
          className={`word-char ${isCompleted ? 'completed' : ''} ${isCurrent ? 'current' : ''}`}
        >
          {char}
        </span>
      );
    });
  };

  return (
    <div className="word-display">
      <div className="target-word">
        {renderWord()}
      </div>
      
      {image && (
        <div className="word-image">
          <img src={image} alt={targetWord} className="word-thumbnail" />
        </div>
      )}
      
      {description && (
        <div className="word-description">{description}</div>
      )}
    </div>
  );
}

export default WordDisplay;